import { gql } from '@apollo/client';
import React, { useEffect } from 'react';
import { Stack, Button, Text } from '@moda/om';
import { PumoModuleSlide, PUMO_MODULE_SLIDE_FRAGMENT } from '../PumoModuleSlide';
import { PumoLivestreamModuleFragment } from '../../generated/types/PumoLivestreamModuleFragment';
import { loadBambuser } from '../../lib/bambuser';
import { MINUTES_TO_SECONDS, SECONDS_TO_MILLISECONDS } from '../../constants/time';

import './PumoLivestreamModule.scss';

export interface Props {
  livestream: PumoLivestreamModuleFragment;
}

export const PUMO_LIVESTREAM_MODULE_FRAGMENT = gql`
  fragment PumoLivestreamModuleFragment on LivestreamPumoModule {
    id
    slides {
      ...PumoModuleSlideFragment
    }
    livestreamId: livestream_id
    headlineBody: headline_body
    ctaBeforeShowText: cta_before_show_text
    ctoBeforeShowUrl: before_cta_url
    ctaAfterShowText: cta_after_show_text
    startDate: start_date
  }
  ${PUMO_MODULE_SLIDE_FRAGMENT}
`;

export const PumoLivestreamModule: React.FC<Props> = ({ livestream }) => {
  useEffect(() => {
    loadBambuser(livestream.livestreamId);
  }, [livestream.livestreamId]);

  const timeZone = new Date(livestream.startDate.replace(/\s+/g, 'T') + 'Z');
  const timeOffset = new Date().getTimezoneOffset();
  const formattedDate = new Date(
    timeZone.getTime() + timeOffset * MINUTES_TO_SECONDS * SECONDS_TO_MILLISECONDS
  );

  return (
    <div className="PumoLivestreamModule">
      <div className="PumoLivestreamModule__image">
        {livestream.slides.map((slide, index) => (
          <PumoModuleSlide key={index} slide={slide} className="PumoLivestreamModule__image" />
        ))}
      </div>
      <Stack className="PumoLivestreamModule__side" space={4} justifyContent="center">
        <Text
          dangerouslySetInnerHTML={{
            __html: livestream.headlineBody
          }}
        />
        {formattedDate < new Date() ? (
          <Button
            className="PumoLivestreamModule__button"
            id={`liveshopping-${livestream.livestreamId}`}
          >
            {livestream.ctaAfterShowText}
          </Button>
        ) : livestream.ctoBeforeShowUrl !== '' ? (
          <Button
            className="PumoLivestreamModule__button"
            href={livestream.ctoBeforeShowUrl}
            rel="noopener noreferrer"
            target="_blank"
          >
            {livestream.ctaBeforeShowText}
          </Button>
        ) : (
          <Button
            className="PumoLivestreamModule__button"
            id={`liveshopping-${livestream.livestreamId}`}
          >
            {livestream.ctaBeforeShowText}
          </Button>
        )}
      </Stack>
    </div>
  );
};
